import _ from "lodash";
import React from "react";
import { FormattedMessage } from "react-intl";
import classnames from "classnames";

import { WeekDaysList } from "../weekDaysList/WeekDaysList";
import { useSchedulerContext } from "../../../SchedulerContext";
import { ScheduleDuration } from "../../scheduleDuration/scheduleDuration";
import { EditScheduleButton } from "../scheduleRulesDialog/editRuleDialog";
import { RemoveScheduleButton } from "../scheduleRulesDialog/removeRuleDialog";

import "./ScheduleRulesTable.scss";

const COLUMNS = [
  {
    id: "days",
    header: <FormattedMessage id={"days"} />,
    cell: (schedule) => (
      <WeekDaysList days={schedule.day} type={schedule.type} />
    ),
  },
  {
    id: "duration",
    header: <FormattedMessage id={"duration"} />,
    cell: ({ timeStart, timeEnd }, context) => {
      const { timeFormat24h } = context;

      return (
        <ScheduleDuration
          timeStart={timeStart}
          timeEnd={timeEnd}
          timeFormat={timeFormat24h}
        />
      );
    },
  },
  {
    id: "actions",
    header: <FormattedMessage id="actions" />,
    cell: (schedule, context) => (
      <div className={"schedule-rules-table__actions"}>
        <EditScheduleButton
          schedule={schedule}
          context={context}
          className={"plain-button edit-action"}
        />
        <RemoveScheduleButton
          schedule={schedule}
          className={"plain-button delete-action"}
        />
      </div>
    ),
  },
];

export const ScheduleRulesTable = ({ schedules }) => {
  const context = useSchedulerContext();

  return (
    <table className="table schedule-rules-table">
      <caption className="sr-only">
        <FormattedMessage id="schedule_rules_table_caption" />
      </caption>
      <thead>
        <tr>
          {COLUMNS.map((column) => (
            <th
              key={column.id}
              scope="col"
              className={classnames(`schedule-rules-table__header`)}
            >
              {column.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {!_.isEmpty(schedules) ? (
          schedules.map((schedule, index) => (
            <tr
              className="schedule-rules-table__row"
              key={index}
              data-testid={schedule.name}
            >
              {COLUMNS.map((column) => (
                <td key={column.id}>{column.cell(schedule, context)}</td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <td
              colSpan={COLUMNS.length}
              className={"schedule-rules-table--empty"}
            >
              <FormattedMessage id="no_schedule_rules" />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
